import { isClient } from './env';

const DEFAULT_LANGUAGE = 'nl-NL';

export const getBrowserLanguage = () =>
    isClient()
        ? navigator?.languages?.[0] || navigator?.language || DEFAULT_LANGUAGE
        : DEFAULT_LANGUAGE;

/**
 * @example
 * `en-US` => `en`
 * `nl-NL` => `nl`
 */
export const getLanguageCode = (language: string) => language.split('-')[0];
